export const Languages = [
  { lng: "es", label: "Español" },
  { lng: "en", label: "English" },
];
